<div class="row dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="col-11 left">
        <h4>{{ 'shared.buttons.scd-add-person' | translate }}</h4>
    </div>
    <div class="col-1 right">
        <button (click)="dialogRef.close()">
            <i class="a-icon a-icon--close"></i>
        </button>
    </div>
</div>
<div class="row mb-2">
    <div class="col-9">
        <div class="d-flex flex-wrap gap-10">
            <mat-form-field class="mat-custom mat-fix-padding" appearance="fill">
                <mat-label>{{ 'shared.miscellaneous.lastname' | translate }}</mat-label>
                <input
                    #searchInput2
                    (keyup)="applyFilter($event)"
                    [ngModel]="surName"
                    (ngModelChange)="onSurNameChange($event)"
                    matInput
                />
            </mat-form-field>
            <mat-form-field class="mat-custom mat-fix-padding" appearance="fill">
                <mat-label>{{ 'shared.miscellaneous.firstname' | translate }}</mat-label>
                <input
                    (keyup)="applyFilter($event)"
                    [ngModel]="firstName"
                    (ngModelChange)="onFirstNameChange($event)"
                    matInput
                />
            </mat-form-field>
            <mat-form-field class="mat-custom mat-fix-padding" appearance="fill">
                <mat-label>{{ 'shared.properties.e-mail' | translate }}</mat-label>
                <input
                    (keyup)="applyFilter($event)"
                    [ngModel]="eMail"
                    (ngModelChange)="onEMailChange($event)"
                    matInput
                />
            </mat-form-field>
        </div>
    </div>
    <div class="col-3 d-flex align-center justify-content-end">
        <ceres-button (click)="applyFilter($event)" [icon]="'search'">
            {{ 'shared.buttons.search-button' | translate }}
        </ceres-button>
    </div>
</div>
@if ((loading$ | async) === false) {
    <div class="row">
        <div class="col-12">
            <div class="table-container">
                <mat-table [dataSource]="dataSource" matSort>
                    <ng-container matColumnDef="selected">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <mat-checkbox
                                [ngModel]="element.selected"
                                (ngModelChange)="onElementSelectedChange(element, $event)"
                                (change)="changeSelected(element, $event)"
                            ></mat-checkbox>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="surName">
                        <mat-header-cell *matHeaderCellDef
                            ><span>{{ 'shared.miscellaneous.lastname' | translate }}</span></mat-header-cell
                        >
                        <mat-cell *matCellDef="let element">{{ element.surName }}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="firstName">
                        <mat-header-cell *matHeaderCellDef
                            ><span>{{ 'shared.miscellaneous.firstname' | translate }}</span></mat-header-cell
                        >
                        <mat-cell *matCellDef="let element">{{ element.firstName }}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="eMail">
                        <mat-header-cell *matHeaderCellDef
                            ><span>{{ 'shared.properties.e-mail' | translate }}</span></mat-header-cell
                        >
                        <mat-cell *matCellDef="let element">{{ element.mail }}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="department">
                        <mat-header-cell *matHeaderCellDef
                            ><span>{{ 'shared.properties.department' | translate }}</span></mat-header-cell
                        >
                        <mat-cell *matCellDef="let element">{{ element.department }}</mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
            </div>
        </div>
    </div>
}
@if (loading$ | async) {
    <ceres-loading [insideTable]="true"></ceres-loading>
}
<div class="row mt-2">
    <div class="col-12">
        <div class="d-flex gap-10">
            <ceres-button (click)="closeDialog()" [icon]="'check-mark'">
                {{ 'shared.buttons.apply' | translate }}
            </ceres-button>
            <ceres-button (click)="dialogRef.close()" [style]="'red'" [icon]="'close'">
                {{ 'shared.buttons.cancel' | translate }}
            </ceres-button>
        </div>
    </div>
</div>
